/* eslint-disable react-hooks/exhaustive-deps */
import './index.css'
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataGrid } from '@mui/x-data-grid'

import { Dialog } from '@progress/kendo-react-dialogs'

import LoadingOverlay from 'components/Common/Overlay/LoadingOverlay'
import ConfirmDialog from 'components/Common/Dialog/ConfirmDialog'

import VaultBOAddPopup from 'components/Vault/VaultBOAddPopup'

import sendIcon from 'assets/vault icons/send.svg'
import deleteIcon from 'assets/vault icons/delete.svg'
import shareIcon from 'assets/vault icons/share.svg'
import historyIcon from 'assets/vault icons/history.svg'
import iconSuccess from 'assets/icons/fi_check-circle.svg'
import Tooltip from '@mui/material/Tooltip'

import { VaultAPI } from 'api'
import actionTypes from 'store/actions'
import VaultBODHistoryPopup from '../VaultBODHistoryPopup'
import Button from 'components/Common/Button'
import { Box, Typography } from '@mui/material'
import ShareModal from './shareModal'
import iconDanger from 'assets/icons/fi_alert-icon.svg'

const sx = {
  header: {
    padding: '0 0 50px 0',

    h6: {
      color: '#25245F',
    },

    p: {
      color: '#66668F',
      marginTop: '10px',
    },
  },

  tableBox: {
    height: '500px',
    width: '100%',
  },

  table: {
    backgroundColor: '#ffffff',
    borderRadius: '10px',
    padding: '10px 0',
    color: '#66668F',
    border: 'none',
    boxShadow: '4px 4px 15px rgba(10, 120, 205, 0.08)',

    img: {
      width: '16px',
      height: '16px',
      cursor: 'pointer',
    },

    '.MuiDataGrid-cell, .MuiDataGrid-cell:focus, .MuiDataGrid-columnHeader:focus, .MuiDataGrid-columnHeader:focus-within':
    {
      outline: 'none',
      whiteSpace: 'normal !important',
    },

    '.MuiDataGrid-columnHeaders': {
      color: '#25245F',
    },

    '.MuiDataGrid-columnSeparator': {
      visibility: 'hidden',
    },

    '.MuiCheckbox-root': {
      color: '#BDBDCE',
    },

    '.MuiDataGrid-sortIcon': {
      color: '#25245F',
      opacity: 'inherit !important',
    },

    '& .MuiDataGrid-iconButtonContainer': {
      visibility: 'visible !important',
    },

    '.MuiDataGrid-overlay': {
      zIndex: '0',
    },
  },

  verified: {
    backgroundColor: '#00CBA9',
    color: '#ffffff',

    '.MuiChip-icon': {
      color: '#ffffff',
    },
  },

  buttonHolder: {
    marginTop: '30px',
  },

  buttonVault: {
    '.MuiTypography-root': {
      textTransform: 'initial',
    },
  },

  tooltip: {
    fontSize: '12px',
    backgroundColor: '#0A78CD',

    '.MuiTooltip-arrow': {
      color: '#0A78CD',
    },
  },
}

const VaultBOD = () => {
  const dispatch = useDispatch()
  const BOs = useSelector(state => state.vaultReducer.BOs)
  const loadingBOs = useSelector(state => state.vaultReducer.loadingBOs)
  const loadingVaultSummary = useSelector(state => state.vaultReducer.loadingVaultSummary)
  const vaultInfo = useSelector(state => state.vaultReducer.vaultSummary)

  const [selectedToRemove, setSelectedToRemove] = useState([])
  const [selectedBOs, setSelectedBOs] = useState([])
  const [selectedDatum, setDatum] = useState(false)
  const [showBOAdd, setShowBOAdd] = useState(false)
  const [showRemoveConfirmPopup, setShowRemoveConfirmPopup] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [isResend, setIsResend] = useState(false)
  const [historyPopup, setHistoryPopup] = useState(false)
  const [historyPopupData, setHistoryPopupData] = useState(false)

  const [showSharePopup, setShowSharePopup] = useState(false)
  const [showCantSharePopup, setShowCantSharePopup] = useState(false)
  // const [isAllVerified, setVerified] = useState([])

  const columns = [
    {
      field: 'type',
      headerName: 'OWNER TYPE',
      sortable: false,
      width: 180,
      valueGetter: params => (params.row.type === 'B' ? 'Business' : 'Individual'),
    },
    {
      field: 'first_name',
      headerName: 'NAME',
      sortable: false,
      width: 230,
      valueGetter: params =>
        params.row.type === 'B' ? params.row.business_name : params.row.first_name + ' ' + params.row.last_name,
    },
    {
      field: 'email_address',
      headerName: 'EMAIL',
      sortable: false,
      width: 350,
    },
    {
      field: 'status',
      headerName: 'STATUS',
      sortable: false,
      width: 160,
      renderCell: params => (params.value === 'P' ? 'Email sent' : 'Form completed'),
    },
    {
      headerName: '',
      field: 'history',
      sortable: false,
      width: 50,
      renderCell: function ({ row }) {
        return (
          <Tooltip componentsProps={{ tooltip: { sx: sx.tooltip } }} title="History" arrow placement="top">
            <img src={historyIcon} onClick={() => onBOHistory(row)} alt="history" />
          </Tooltip>
        )
      },
    },

    {
      // renderHeader: function ({ row }) {
      //   return (
      //     <Tooltip componentsProps={{ tooltip: { sx: sx.tooltip } }} title="Resend" arrow placement="top">
      //       <img src={sendIcon} onClick={() => onResendBO(row.t_beneficial_owner_id)} alt="send" />
      //     </Tooltip>
      //   )
      // },
      field: ' ',
      sortable: false,
      width: 50,
      renderCell: function ({ row }) {
        return (
          <Tooltip componentsProps={{ tooltip: { sx: sx.tooltip } }} title="Resend" arrow placement="top">
            <img src={sendIcon} onClick={() => onResendBO(row.t_beneficial_owner_id)} alt="send" />
          </Tooltip>
        )
      },
    },

    {
      renderHeader: function ({ row }) {
        return selectedBOs.length ? (
          <Tooltip componentsProps={{ tooltip: { sx: sx.tooltip } }} title="Share" arrow placement="top">
            <img src={shareIcon} onClick={() => onShareBO(false)} alt="share" />
          </Tooltip>
        ) : (
          <Tooltip componentsProps={{ tooltip: { sx: sx.tooltip } }} title="Please select BO" arrow placement="top">
            <img src={shareIcon} alt="share all" />
          </Tooltip>
        )
      },
      field: 'share',
      sortable: false,
      width: 50,
      renderCell: function ({ row }) {
        return (
          <Tooltip componentsProps={{ tooltip: { sx: sx.tooltip } }} title="Share" arrow placement="top">
            <img src={shareIcon} onClick={() => onShareBO(row.t_beneficial_owner_id)} alt="share" />
          </Tooltip>
        )
      },
    },

    {
      renderHeader: function ({ row }) {
        return (
          <Tooltip componentsProps={{ tooltip: { sx: sx.tooltip } }} title="Delete" arrow placement="top">
            <img src={deleteIcon} onClick={onRemoveBOs} alt="delete" />
          </Tooltip>
        )
      },
      field: 'delete',
      sortable: false,
      width: 50,
      renderCell: function ({ row }) {
        return (
          <Tooltip componentsProps={{ tooltip: { sx: sx.tooltip } }} title="Delete" arrow placement="top">
            <img src={deleteIcon} onClick={() => onRemoveBO(row.t_beneficial_owner_id)} alt="delete" />
          </Tooltip>
        )
      },
    },
  ]

  useEffect(() => {
    if (!vaultInfo.vault_id) {
      return
    }

    if (!loadingVaultSummary) VaultAPI.fetchingBOs(dispatch, vaultInfo?.vault_id, vaultInfo?.business_id)
  }, [vaultInfo.vault_id])

  const onShareBO = boId => {
    if (BOs && BOs.length < 1) {
      return
    }
    let any
    setDatum(boId)
    if (boId === false) {
      any = BOs.find(x => selectedBOs.includes(x.t_beneficial_owner_id) && x.status === 'P')
    } else {
      any = BOs.find(x => boId === x.t_beneficial_owner_id && x.status === 'P')
    }
    if (any) {
      setShowCantSharePopup(true)
    } else {
      setShowSharePopup(true)
    }
  }

  const onBOHistory = dataItem => {
    setHistoryPopup(true)
    setHistoryPopupData(dataItem)
  }

  const onResendBO = boId => {
    VaultAPI.resendInvitation(vaultInfo?.vault_id, boId)
    const operation = 'Email Resent'
    VaultAPI.submitBOHistory(boId, operation)
    setIsSubmitted(true)
    setIsResend(true)
  }

  const onRemoveBOs = () => {
    if ((BOs && BOs.length < 1) || selectedBOs.length < 1) {
      return
    }
    setSelectedToRemove(selectedBOs)
    setShowRemoveConfirmPopup(true)
  }

  const onRemoveBO = boId => {
    setShowRemoveConfirmPopup(true)
    setSelectedToRemove([boId])
  }

  const removeBO = () => {
    setShowRemoveConfirmPopup(false)
    setSelectedBOs([])
    VaultAPI.removeBOs(dispatch, vaultInfo?.vault_id, vaultInfo?.business_id, selectedToRemove)
  }

  const onAddBO = () => {
    setShowBOAdd(!showBOAdd)
  }

  const onCloseBOAddPopup = () => {
    setShowBOAdd(!showBOAdd)
    dispatch({ type: actionTypes.VAULTRESETDRAFTBO })
  }

  const boFormSumitted = () => {
    setIsSubmitted(true)
    setShowBOAdd(false)
  }
  const handleCheckBox = () => {
    setSelectedBOs([])
  }

  function handleSelectionModelChange(ids) {
    setSelectedBOs(ids)
  }

  return (
    <div className="vault-bod">
      <Box sx={{ marginY: '30px', width: '823px' }}>
        <Typography variant="body1" color="#66668F">
          Beneficial owner information will be stored securely by Markaaz, and is not viewable in the Dashboard as it
          contains sensitive information.
        </Typography>
      </Box>

      <div className="vault-bod-table-wrapper">
        {(loadingBOs || loadingVaultSummary) && (
          <LoadingOverlay
            style={{
              top: '4rem',
              height: 'calc(100% - 4rem)',
              fontSize: '6rem',
            }}
          />
        )}

        <>
          <Box sx={sx.tableBox}>
            <DataGrid
              rowHeight={100}
              sx={sx.table}
              getRowId={row => row.t_beneficial_owner_id}
              rows={BOs}
              columns={columns}
              pageSize={5}
              rowsPerPageOptions={[5]}
              disableColumnMenu={true}
              selectionModel={selectedBOs}
              checkboxSelection
              onSelectionModelChange={handleSelectionModelChange}
              disableSelectionOnClick={true}
            />
          </Box>
        </>
      </div>
      <Box sx={{ marginTop: '40px' }}>
        <Button onClick={onAddBO}>
          <span className="text-bold"> Add beneficial owners</span>
        </Button>
      </Box>
      {showBOAdd && <VaultBOAddPopup submitted={() => boFormSumitted()} onClose={onCloseBOAddPopup} />}
      {showRemoveConfirmPopup && (
        <ConfirmDialog
          show={showRemoveConfirmPopup}
          setShow={() => setShowRemoveConfirmPopup(false)}
          onSuccess={removeBO}
          SuccessMessage="Remove"
          title="Are You Sure?"
          content="Do you want to proceed with removing selected beneficial owner(s) from the Vault?"
        />
      )}
      {isSubmitted && (
        <Dialog width="550px" height="310px">
          <Box textAlign="center" className="popUp" justifyContent="center">
            {isResend ? (
              <Box fontSize="20px" marginBottom="6%" marginTop="8%" fontWeight="bold">
                Resent!
              </Box>)
              :
              (<Box fontSize="20px" marginBottom="6%" marginTop="8%" fontWeight="bold">
                <img src={iconSuccess} alt="success" height={50} width={50} />
              </Box>
              )}
            {isResend ? (
              <Box fontSize="14px" marginBottom="10%" marginX="25px">
                A new email will be sent to the beneficial owner(s) and <br />
                you will also receive a confirmation email once they <br />
                have provided information.
              </Box>
            ) : (
              <Box fontSize="14px" marginBottom="10%" marginX="25px">
                An email will be sent to the beneficial owner(s) and you <br />
                will also receive a confirmation email once they <br />
                have provided information.
              </Box>
            )}
            <Button
              onClick={() => {
                setIsSubmitted(false)
                setHistoryPopup(false)
                setIsResend(false)
              }}
              sx={{ width: '250px', fontWeight: 'bold', height: '50px' }}
            >
              Close
            </Button>
          </Box>
        </Dialog>
      )}
      {historyPopup && <VaultBODHistoryPopup document={historyPopupData} onClose={() => setHistoryPopup(false)} />}
      {showSharePopup && (
        <Dialog width="570px" onClose={() => setShowSharePopup(false)}>
          <ShareModal
            data={{
              secShareType: 'beneficial_owner',
              selectedId: selectedBOs,
            }}
            vaultInfo={vaultInfo}
            datam={selectedDatum}
            callBack={handleCheckBox}
            docs={BOs}
            onClose={() => setShowSharePopup(false)}
          />
        </Dialog>
      )}

      {showCantSharePopup && (
        <Dialog width="570px" height="300px">
          <Box
            marginTop="30px"
            display="flex"
            textAlign="center"
            flexDirection="column"
            justifyContent="center"
            gap="35px"
          >
            <Box>
              <img src={iconDanger} alt="success" height={50} width={50} />
            </Box>
            <Box fontSize="14px" marginX="10px" color="#66668F">
              <Typography color="#66668F" variant="body1">
                Beneficial owner(s) cannot be shared until they have completed the form.
              </Typography>
            </Box>
            <Box display="flex" textAlign="center" justifyContent="center">
              <Button onClick={() => setShowCantSharePopup(false)} sx={{ width: '250px', fontWeight: 'bold' }}>
                Close
              </Button>
            </Box>
          </Box>
        </Dialog>
      )}
    </div>
  )
}

export default VaultBOD
